import React, { Component } from "react";
import "./SortingOptions.scss";
import { IonRow, IonCol, IonModal, IonIcon, IonButton } from "@ionic/react";
import i18n from '../../../../i18n';
import { SORT_OPTIONS } from "../../../utils/constants";

export interface ISortEvents {
  hideSortingOptions: Function;
  onConfirm: Function;
  dropdownClick: Function;
  sortBy: Function;
  onClickSortArrows: Function;
  onCancelDropdown: Function;
  dismissModal: Function;
}

class SortingOptions extends Component<any, any> implements ISortEvents {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedOption: this.props?.selectedOption || this.props.options[0],
      clickedOption: this.props?.selectedOption || this.props.options[0],
      asc: (this.props.selectedOption && this.props.selectedOption.sortDirection === "asc" ? true : false) || true,
      isDropdown: false,
      upArrow: "assets/icon/sort icon.svg",
      downArrow: "assets/icon/sort icon downward.svg",
      selectedValue: (this.props?.selectedOption?.value) || this.props.options[0].value,
      isSearchById: this.props.isSearchById !== undefined ? this.props.isSearchById : false
    };
  }
  hideSortingOptions = (option: any) => {
    this.setState({ clickedOption: option });
  };
  onConfirm = async(clickedOptionValue: string) => {
    this.setState({
      selectedValue: this.state.selectedOption.value,
      selectedOption: this.state.clickedOption,
      asc: (this.state.clickedOption.value !== SORT_OPTIONS.price)
    });
    this.sortBy(clickedOptionValue);
  };
  dropdownClick = () => {
    this.setState({ isDropdown: true });
  };
  sortBy = (value: string) => {
    const { asc } = this.state;
    this.setState({ isDropdown: false });
    !this.state.isSearchById && this.props.sortedData(value, asc, this.state.clickedOption.name);
  };
  onClickSortArrows = () => {
    this.setState(
      {
        asc: !this.state.asc,
      },
      () => {
        this.sortBy(this.state.selectedOption.value);
      }
    );
  };
  onCancelDropdown = () => {
    this.setState({
      isDropdown: false,
      clickedOption: this.state.selectedOption,
    })
  };
  dismissModal = () => {
    this.setState({
      isDropdown: false,
    });
  };

  render() {
    const sortByOptions = this.props.options;
    return (
      <>
        <div className="search_sortby_select" data-test="dropdown-div-click" onClick={this.dropdownClick}>
          <div className="search_sort_button" data-test="dropdown-click">
            <label className="selected_label">
              <span className="text_BY">{i18n.t('By')} </span> {this.state.selectedOption.name}
            </label>
          </div>
          <i className="down"></i>
        </div>
        <div data-test="sort-arrows"
          className="sortArrows"
          onClick={this.onClickSortArrows}
        >
          <IonIcon
            src={
              this.state.asc === true
                ? this.state.upArrow
                : this.state.downArrow
            }
          ></IonIcon>
        </div>
        <IonModal
          show-backdrop={true}
          backdrop-dismiss={false}
          isOpen={this.state.isDropdown}
          cssClass="dropdown-modal"
          onDidDismiss={this.dismissModal}
        >
          <div className="search_options">
            <IonRow class="dropdown-row dropdown-heading">
              <IonCol>
                {" "}
                <p className="sortBy_text">{i18n.t('Sort by')}</p>{" "}
              </IonCol>
            </IonRow>
            {sortByOptions.map((option: any, k: any) => (
              <IonRow data-test="hide-drop"
                class="dropdown-row"
                key={k}
                onClick={() => this.hideSortingOptions(option)}
              >
                <IonCol
                  class={
                    option.name === this.state.clickedOption.name
                      ? "checked"
                      : ""
                  }
                >
                  {i18n.t(option.name)} <i className="check"></i>{" "}
                </IonCol>
              </IonRow>
            ))}
            <IonRow className="ion-margin">
              <IonCol size="6" className="ion-text-right">
                <IonButton
                  className="secondary-cta-btn-mobile"
                  data-test="dropdown_cancel"
                  onClick={this.onCancelDropdown}
                >
                {i18n.t('Cancel')}
                </IonButton>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonButton
                  className="primary-cta-btn-mobile"
                  data-test="validate-btn"
                  onClick={() => this.onConfirm(this.state.clickedOption.value)}
                >
                {i18n.t('Ok_TEXT')}
                </IonButton>
              </IonCol>
            </IonRow>
          </div>
        </IonModal>
      </>
    );
  }
}

export default SortingOptions;
